import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  BasicDialogService,
  ConnectedDialogConfig,
} from '@principle-theorem/ng-shared';
import {
  type IServiceCode,
  type IServiceCodeEntry,
} from '@principle-theorem/principle-core/interfaces';
import {
  AddServiceCodeDialogComponent,
  type IAddServiceCodeDialogData,
} from '../add-service-code-dialog/add-service-code-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'pr-add-service-code-button',
  templateUrl: './add-service-code-button.component.html',
  styleUrls: ['./add-service-code-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
})
export class AddServiceCodeButtonComponent {
  @Input() connectedTo: ElementRef<HTMLElement>;
  @Input() commonCodes: IServiceCodeEntry[] = [];
  @Input() disabled = false;
  @Input() offsetX = 0;
  @Input() offsetY = 0;
  @Input() label = 'Add Service Code';
  @Input() type: 'icon' | 'button' = 'button';
  @Output() codeSelected = new EventEmitter<IServiceCode>();

  constructor(private dialogService: BasicDialogService) {}

  async openAddServiceCode(): Promise<void> {
    const serviceCode = await this.dialogService
      .connected<
        IAddServiceCodeDialogData,
        IServiceCode,
        AddServiceCodeDialogComponent
      >(
        AddServiceCodeDialogComponent,
        this.getAddServiceCodeDialogConfig({
          commonCodes: this.commonCodes,
        })
      )
      .closed.toPromise();

    if (serviceCode) {
      this.codeSelected.emit(serviceCode);
    }
  }

  private getAddServiceCodeDialogConfig(
    data: IAddServiceCodeDialogData
  ): ConnectedDialogConfig<
    IAddServiceCodeDialogData,
    IServiceCode,
    AddServiceCodeDialogComponent
  > {
    return {
      data,
      connectedTo: this.connectedTo,
      width: `${String(this.connectedTo.nativeElement.clientWidth)}px`,
      positions: [
        {
          panelClass: ['pt-connected-dialog-container'],
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
          offsetX: this.offsetX,
          offsetY: this.offsetY,
        },
        {
          panelClass: ['pt-connected-dialog-container'],
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
          offsetX: this.offsetX,
          offsetY: -this.offsetY,
        },
      ],
      autoFocus: true,
    };
  }
}
